import StructuredTextParser from '@app-ila/components/Utility/StructuredTextParser';
import { Box, Flex, Text } from '@chakra-ui/react';
import LazyLoadImageComponent from '@components/UI/LazyLoadImageComponent';
import { render } from 'datocms-structured-text-to-html-string';

/**
 *
 * @param {Object} card
 * @returns
 */
const GenWhoShouldSection = ({ card, mergeBottom, ...props }) => {
  return (
    <Flex {...props}>
      <Flex
        flexDir={{ base: 'row', md: 'column' }}
        mb={{ base: '24px', md: '0' }}
        alignItems={{ base: 'flex-end', md: 'flex-start' }}
      >
        <Text
          maxW={{ base: 152, md: 218 }}
          color="#FFF"
          fontFamily="var(--FedraSansStd-medium)"
          fontSize={"20px"}
          fontStyle="normal"
          fontWeight="500"
          lineHeight="24px"
          mb={mergeBottom || '0px'}
          display={{ base: 'contents', md: 'block' }}
        >
          {card?.title}
        </Text>
      </Flex>
      <StructuredTextParser
        color="#D4D4FA"
        fontFamily="var(--FedraSansStd-book)"
        fontSize={{ base: '16px', sm:"16px", md: '18px' }}
        fontStyle="normal"
        fontWeight="400"
        lineHeight={'160%'}
        str={render(card?.description)}
      />
    </Flex>
  );
};

export default GenWhoShouldSection;
